import { Component, TemplateRef, ViewChild, OnInit, ViewChildren, QueryList, ElementRef, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router, IsActiveMatchOptions } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { LeapmotorUserDTO } from '../../../models/user-dto';
import { LeapmotorNotificationDTO } from '../../../models/notification-dto';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',

})
export class HeaderComponent implements OnInit {

  user!: LeapmotorUserDTO;

   //#region VARIABLES NOTIFICACIONES
   data: LeapmotorNotificationDTO[] = [];
   countNotification: number = 0;
   page: number = 0;
   showMore: boolean = true;
   loading: boolean = true;
   showNotifications: boolean = false;
   //#endregion

  constructor(
    private router: Router, 
    private userService: UserService,
  private notificationService:NotificationService) {

    this.getUser();
  }
  getUser() {
    this.userService.getUserData().subscribe(resp => {
      this.user = resp;

    });
  }
  ngOnInit() {
    this.getCountNotification();
  }

   //#region NOTIFICACIONES
   resetData() {
    this.data = [];
    this.page = 0;
    this.showMore = true;
    this.loading = true;
  }

  loadEvents() {
    const that = this;
    $('#sidebarCollapse').on('click', function () {
      $('#sidebar').toggleClass('active');
    });
  }

  getContentNotification() {
    const that = this;
    if (that.showMore == true) {
      this.notificationService.getUserAvailableNotification(that.page).subscribe(resp => {
        Array.prototype.push.apply(that.data, resp);
        that.showMore = (that.data.length != that.countNotification);
        that.loading = false;
      }, (err) => {

      });
    }
  }

  getCountNotification(show?) {
    const that = this;

    if (show)
      this.showNotificationList();
    this.resetData();
    this.getContentNotification();
    this.notificationService.getUserNotificationCount().subscribe(resp => {
      this.countNotification = resp;
    }, (err) => {
    });
  }


  loadMore() {
    this.page++;
    this.getContentNotification();
  }

  showNotificationList() {

    this.showNotifications = true;

  }

  closeNotificationView() {

    this.showNotifications = false;
    document.getElementById('closeModalButton').click();
  }


  closeNotification(idNotification) {
    this.notificationService.updateNotificationUser(idNotification).subscribe(resp => {
      this.getCountNotification();
      this.closeNotificationView();
    });
  }

  //#endregion


}
